module.exports = __webpack_public_path__ + "training-pc/static/img/news.59395198.png";